module.exports = __webpack_public_path__ + "img/e2-en.63ebceb1.jpeg";